<template>
    <h2>Mercato {{ mainStore?.mercato }}</h2>
    <h2>Cerca il veicolo commerciale</h2>

    <div class="h-[1px] bg-[#e96932] block w-full relative text-center mb-[20px]"></div>

    <Popup v-if="isNoDataPopupOpen" title="Veicolo non trovato" :data="datiVeicoloNonDisponibile"
        @close="isNoDataPopupOpen = false" />

    <div v-if="mainStore?.cliente?.ricercaTargaIn?.includes('vc') && mainStore?.mercato === 'usato'"
        class="flex justify-between flex-wrap gap-[20px]">
        <div class="inline-block w-full sm:w-[48%]">
            <label>Targa:</label>
            <input type="text" v-model="targa" placeholder="Targa" />
            <div v-if="isLicensePlatesListVisible && vehicleSearched?.versioni?.length > 0"
                class="bg-white block border border-[#ccc] border-t-0 w-full rounded-[10px] z-[1] max-h-[200px] overflow-auto shadow-[0_3px_6px_rgba(0,0,0,0.16)]">
                <ul v-if="vehicleSearched?.versioni?.length > 0" class="list-none block w-full text-sm m-0 p-0">
                    <li v-for="(item, index) in vehicleSearched.versioni" :key="index"
                        class="list-none block w-full cursor-pointer m-0 p-0 hover:bg-[#ccc]"
                        @click="saveVehicle(item)">
                        <div class="block w-full text-black text-left border border-top-[#ccc] m-0 py-[8px] px-[15px]">
                            {{ item?.marca?.nome }} {{ item?.versione }}<br>{{ format(item?.da, "YYYY-MM-DD", "MM/YYYY")
                            }} - {{ format(item?.a, "YYYY-MM-DD", "MM/YYYY") }}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="flex justify-end">
            <button class="button w-[150px] h-[50px] sm:mt-[20px]" @click="searchVehicle">Ricerca</button>
        </div>
    </div>

    <div v-if="mainStore?.mercato === 'usato'" class="block w-full relative text-center my-[20px]">
        <div class="absolute top-[50%] w-full h-[1px] bg-[#e96932] block"></div>
        <span class="bg-[#f8f9fa] relative px-[20px]">Oppure</span>
    </div>

    <div class="flex justify-between flex-wrap mb-[20px]" id="selection">
        <div v-if="isImmatricolazioneEstera && targaEstero" class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                Targa Estera
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled v-model="targaEstero" />
        </div>
        <div v-if="isImmatricolazioneEstera && statoEstero" class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                Stato Estero
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled v-model="statoEstero" />
        </div>
        <div v-if="isImmatricolazioneEstera && dataImmatricolazioneEstero" class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">
                Data immatricolazione Estera
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled v-model="dataImmatricolazioneEstero" />
        </div>
        <div class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Marca</label>
            <select :disabled="isSelectMarcaDisabled" :class="{ 'disabled': isSelectMarcaDisabled }" v-model="marca"
                @change="setMarca">
                <option value="">Seleziona</option>
                <option v-for="(marca, index) in marche" :key="index" :value="marca?.acronimo">
                    {{ marca?.nome }}
                </option>
            </select>
        </div>
        <div v-if="mainStore?.mercato === 'nuovo'" class="hidden sm:inline-block w-[48%] mb-[20px]"></div>

        <div v-if="mainStore?.mercato === 'usato'" class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Anno prima immatricolazione</label>
            <select :disabled="isSelectAnnoDisabled" :class="{ 'disabled': isSelectAnnoDisabled }" v-model="anno"
                @change="setAnno">
                <option value="">Seleziona</option>
                <option v-for="(anno, index) in anni" :key="index" :value="anno">
                    {{ anno }}
                </option>
            </select>
        </div>
        <div v-if="mainStore?.mercato === 'usato'" class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Mese prima immatricolazione</label>
            <select :disabled="isSelectMeseDisabled" :class="{ 'disabled': isSelectMeseDisabled }" v-model="mese"
                @change="setMese">
                <option value="">Seleziona</option>
                <option v-for="(mese, index) in mesi" :key="index" :value="mese">
                    {{ mese }}
                </option>
            </select>
        </div>
        <div class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Gamma</label>
            <select :disabled="isSelectGammaDisabled" :class="{ 'disabled': isSelectGammaDisabled }" v-model="gamma"
                @change="setGamma">
                <option value="">Seleziona</option>
                <option v-for="(gamma, index) in gamme" :key="index" :value="gamma?.codice">
                    {{ gamma?.descrizione }}
                </option>
            </select>
        </div>

        <div class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">Modello</label>
            <div class="w-full overflow-auto">
                <select :disabled="isSelectModelloDisabled" :class="{ 'disabled': isSelectModelloDisabled }"
                    v-model="modello" @change="setModello" style="width: auto; min-width: 100%">
                    <option value="">Seleziona</option>
                    <option v-for="(modello, index) in modelli" :key="index" :value="modello?.codDescModello?.codice">
                        {{ modello?.codDescModello?.descrizione }} ({{ format(modello?.inizioCommercializzazione,
                            "YYYY-MM-DD", "MM/YYYY") }} - {{ format(modello?.fineCommercializzazione, "YYYY-MM-DD",
                            "MM/YYYY") }})
                    </option>
                </select>
            </div>
        </div>
        <div class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Porte</label>
            <select :disabled="isSelectPortaDisabled" :class="{ 'disabled': isSelectPortaDisabled }" v-model="porta"
                @change="setPorta">
                <option value="">Seleziona</option>
                <option v-for="(por, index) in porte" :key="index" :value="por">
                    {{ por }}
                </option>
            </select>
        </div>
        <div class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Tipologia</label>
            <select :disabled="isSelectTipologiaDisabled" :class="{ 'disabled': isSelectTipologiaDisabled }"
                v-model="tipologia" @change="setTipologia">
                <option value="">Seleziona</option>
                <option v-for="(tipologia, index) in tipologie" :key="index" :value="tipologia?.codice">
                    {{ tipologia?.descrizione }}
                </option>
            </select>
        </div>
        <div class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Passo</label>
            <select :disabled="isSelectPassoDisabled" :class="{ 'disabled': isSelectPassoDisabled }" v-model="passo"
                @change="setPasso">
                <option value="">Tutti</option>
                <option v-for="(passo, index) in passi" :key="index" :value="passo">
                    {{ passo }}
                </option>
            </select>
        </div>
        <div class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">Versione</label>
            <div class="w-full overflow-auto">
                <select :disabled="isSelectVersioneDisabled" :class="{ 'disabled': isSelectVersioneDisabled }"
                    v-model="versione" @change="setVersione" style="width: auto; min-width: 100%">
                    <option value="">Seleziona</option>
                    <option v-for="(versione, index) in versioni" :key="index" :value="versione?.codiceEurotax">
                        {{ versione?.nome }} ({{ format(versione?.da, "YYYY-MM-DD", "MM/YYYY") }} - {{
                            format(versione?.a, "YYYY-MM-DD", "MM/YYYY") }})
                    </option>
                </select>
            </div>
        </div>

        <div v-if="mainStore?.mercato === 'usato'" class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Km attuali</label>
            <input type="number" placeholder="Km attuali" v-model="kmAttuali" />
        </div>
        <div class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Km annuali</label>
            <input type="number" placeholder="Km annuali" v-model="kmAnnuali" />
        </div>
        <div v-if="mainStore?.mercato === 'nuovo'" class="hidden sm:inline-block w-[48%] mb-[20px]"></div>

        <div class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">Fino a (max 5 opzioni): </label>
            <div class="flex flex-wrap gap-[30px]">
                <div v-for="(num, idx) in dateFuture" :key="idx" class="button w-[100px] h-[50px]"
                    :class="{ 'button-selected': numeroMesiForecast?.includes(num) }"
                    @click="setNumeroMesiForecast(num)">
                    {{ num }} mesi
                </div>
            </div>
        </div>
    </div>

    <div class="flex justify-end">
        <button class="button p-[15px] sm:p-[20px]" @click="submit">FORECAST</button>
    </div>
</template>

<script>
import axios from 'axios';
import { mainStore } from '../../../../store/main';
import formatter from "../../../formatter";
import Popup from '../Popup.vue';

export default {
    name: 'RicercaCom',

    components: { Popup },

    data() {
        return {
            mainStore,
            marche: [],
            targa: null,
            isDisabled: true,
            anni: [],
            mesi: [],
            isSelectDataDisabled: true,
            isSelectMarcaDisabled: true,
            isSelectAnnoDisabled: true,
            isSelectMeseDisabled: true,
            isSelectModelloDisabled: true,
            isSelectPortaDisabled: true,
            isSelectTipologiaDisabled: true,
            isSelectPassoDisabled: true,
            isSelectGammaDisabled: true,
            isSelectVersioneDisabled: true,
            isPercorrenzaMediaDisabled: true,
            marca: "",
            anno: "",
            gamme: [],
            modelli: [],
            mese: "",
            gamma: "",
            modello: "",
            porta: "",
            porte: [],
            tipologie: [],
            tipologia: "",
            passi: [],
            versioni: [],
            passo: "",
            versione: "",
            vehicleSearched: {},
            isSavingMode: false,
            isLicensePlatesListVisible: false,
            isNoDataPopupOpen: false,
            datiVeicoloNonDisponibile: {},
            isImmatricolazioneEstera: false,
            targaEstero: "",
            statoEstero: "",
            dataImmatricolazioneEstero: "",
            kmAttuali: null,
            kmAnnuali: null,
            numeroMesiForecast: [],
            dateFuture: []
        }
    },

    async created() {
        const loader = this.$loading.show();

        await this.getMarche(this.mainStore?.mercato === 'nuovo');
        this.getDateFuture();

        if (this.mainStore?.datiSearchTargaTipoVeicoloSbagliato != {}) {
            this.targa = this.mainStore.datiSearchTargaTipoVeicoloSbagliato?.targa;
            this.vehicleSearched = this.mainStore.datiSearchTargaTipoVeicoloSbagliato;
            this.isLicensePlatesListVisible = true;
        }

        loader.hide();
    },

    methods: {
        resetForm() {
            this.marca = "";
            this.isSelectAnnoDisabled = true;
            this.anno = "";
            this.anni = [];
            this.isSelectMeseDisabled = true;
            this.mese = "";
            this.isSelectGammaDisabled = true;
            this.gamma = "";
            this.gamme = [];
            this.isSelectModelloDisabled = true;
            this.modello = "";
            this.modelli = [];
            this.isSelectPortaDisabled = true;
            this.porta = "";
            this.porte = [];
            this.isSelectTipologiaDisabled = true;
            this.tipologia = "";
            this.tipologie = [];
            this.isSelectPassoDisabled = true;
            this.passo = "";
            this.passi = [];
            this.isSelectVersioneDisabled = true;
            this.versione = "";
            this.versioni = [];
            this.targaEstero = "";
            this.statoEstero = "";
            this.dataImmatricolazioneEstero = "";
            this.isImmatricolazioneEstera = false;
        },
        format(date, initialFormat, finalFormat) {
            if (!date) {
                return null;
            }
            return formatter.formatDate(date, initialFormat, finalFormat);
        },
        async setMarca() {
            const loader = this.$loading.show();

            this.isSavingMode = false;

            this.targa = null;

            this.anno = "";
            this.mese = "";
            this.isSelectMeseDisabled = true;
            this.gamma = "";
            this.isSelectGammaDisabled = true;
            this.modello = "";
            this.isSelectModelloDisabled = true;
            this.porta = "";
            this.isSelectPortaDisabled = true;
            this.tipologia = "";
            this.isSelectTipologiaDisabled = true;
            this.passo = "";
            this.isSelectPassoDisabled = true;
            this.versione = "";
            this.isSelectVersioneDisabled = true;

            if (this.mainStore?.mercato === 'usato') {
                if (!this.marca) {
                    this.isSelectAnnoDisabled = true;
                } else {
                    this.isSelectAnnoDisabled = true;
                    await this.getAnni();
                    this.isSelectAnnoDisabled = false;
                }
            } else {
                if (!this.marca) {
                    this.isSelectGammaDisabled = true;
                } else {
                    this.isSelectGammaDisabled = true;
                    await this.getGamme(true);
                    this.isSelectGammaDisabled = false;
                }
            }

            loader.hide();
        },
        async setAnno() {
            const loader = this.$loading.show();

            if (this.anno) {
                this.isSelectAnnoDisabled = false;
            }

            if (!this.isSavingMode) {
                this.mese = "";
                this.gamma = "";
                this.isSelectGammaDisabled = true;
                this.modello = "";
                this.isSelectModelloDisabled = true;
                this.porta = "";
                this.isSelectPortaDisabled = true;
                this.tipologia = "";
                this.isSelectTipologiaDisabled = true;
                this.passo = "";
                this.isSelectPassoDisabled = true;
                this.versione = "";
                this.isSelectVersioneDisabled = true;

                if (!this.anno) {
                    this.isSelectMeseDisabled = true;
                } else {
                    this.isSelectMeseDisabled = true;
                    this.getMesi();
                    this.isSelectMeseDisabled = false;
                }
            } else {
                this.isSelectMeseDisabled = false;
            }

            loader.hide();
        },
        async setMese() {
            const loader = this.$loading.show();

            if (this.mese) {
                this.isSelectMeseDisabled = false;
            }

            if (!this.isSavingMode) {
                this.gamma = "";
                this.modello = "";
                this.isSelectModelloDisabled = true;
                this.porta = "";
                this.isSelectPortaDisabled = true;
                this.tipologia = "";
                this.isSelectTipologiaDisabled = true;
                this.passo = "";
                this.isSelectPassoDisabled = true;
                this.versione = "";
                this.isSelectVersioneDisabled = true;

                if (!this.mese) {
                    this.isSelectGammaDisabled = true;
                } else {
                    this.isSelectGammaDisabled = true;
                    await this.getGamme(false);
                    this.isSelectGammaDisabled = false;
                }
            } else {
                this.isSelectGammaDisabled = false;
            }

            loader.hide();
        },
        async setGamma() {
            const loader = this.$loading.show();

            if (this.gamma) {
                this.isSelectGammaDisabled = false;
            }

            if (!this.isSavingMode) {
                this.modello = "";
                this.porta = "";
                this.isSelectPortaDisabled = true;
                this.tipologia = "";
                this.isSelectTipologiaDisabled = true;
                this.passo = "";
                this.isSelectPassoDisabled = true;
                this.versione = "";
                this.isSelectVersioneDisabled = true;

                if (!this.gamma) {
                    this.isSelectModelloDisabled = true;
                } else {
                    this.isSelectModelloDisabled = true;
                    await this.getModelli(this.mainStore.mercato === 'nuovo');
                    this.isSelectModelloDisabled = false;
                }
            } else {
                this.isSelectModelloDisabled = false;
            }

            loader.hide();
        },
        async setModello() {
            const loader = this.$loading.show();

            if (this.modello) {
                this.isSelectModelloDisabled = false;
            }

            if (!this.isSavingMode) {
                this.porta = "";
                this.tipologia = "";
                this.isSelectPassoDisabled = true;
                this.passo = "";
                this.isSelectPassoDisabled = true;
                this.versione = "";
                this.isSelectVersioneDisabled = true;

                if (!this.modello) {
                    this.isSelectPortaDisabled = true;
                } else {
                    this.isSelectPortaDisabled = true;
                    await this.getPorte(this.mainStore.mercato === 'nuovo');
                    this.isSelectPortaDisabled = false;
                }
            } else {
                this.isSelectPortaDisabled = false;
            }

            loader.hide();
        },
        async setPorta() {
            const loader = this.$loading.show();

            if (this.porta) {
                this.isSelectPortaDisabled = false;
            }

            if (!this.isSavingMode) {
                this.tipologia = "";
                this.passo = "";
                this.isSelectPassoDisabled = true;
                this.versione = "";
                this.isSelectVersioneDisabled = true;

                if (!this.porta) {
                    this.isSelectTipologiaDisabled = true;
                } else {
                    this.isSelectTipologiaDisabled = true;
                    await this.getTipologie(this.mainStore.mercato === 'nuovo');
                    this.isSelectTipologiaDisabled = false;
                }
            } else {
                this.isSelectTipologiaDisabled = false;
            }

            loader.hide();
        },
        async setTipologia() {
            const loader = this.$loading.show();

            if (this.modello) {
                this.isSelectTipologiaDisabled = false;
            }

            if (!this.isSavingMode) {
                this.passo = "";
                this.versione = "";
                this.isSelectVersioneDisabled = true;

                if (!this.tipologia) {
                    this.isSelectPassoDisabled = true;
                } else {
                    this.isSelectPassoDisabled = true;
                    await this.getPassi(this.mainStore.mercato === 'nuovo');
                    this.isSelectPassoDisabled = false;
                }
            } else {
                this.isSelectPassoDisabled = false;
            }

            loader.hide();
        },
        async setPasso() {
            const loader = this.$loading.show();

            if (this.modello) {
                this.isSelectPassoDisabled = false;
            }

            if (!this.isSavingMode) {
                this.versione = "";

                this.isSelectVersioneDisabled = true;
                await this.getVersioni(this.mainStore.mercato === 'nuovo');
                this.isSelectVersioneDisabled = false;
            } else {
                this.isSelectVersioneDisabled = false;
            }

            loader.hide();
        },
        async setVersione() {
            const loader = this.$loading.show();

            if (this.versione) {
                this.isSelectVersioneDisabled = false;
            }

            const versioneSelected = this.versioni.find(item => item.codiceEurotax === this.versione);
            this.mainStore.allestimentoVeicolo = { marcaNome: versioneSelected?.marca?.nome, versione: versioneSelected?.nome };

            loader.hide();
        },
        setNumeroMesiForecast(num) {
            if (this.numeroMesiForecast.includes(num)) {
                this.numeroMesiForecast = this.numeroMesiForecast.filter(item => item !== num);
            } else {
                if (this.numeroMesiForecast.length < 5) {
                    this.numeroMesiForecast.push(num);
                } else {
                    this.$notify({
                        title: "Attenzione",
                        text: "È possibile selezionare un massimo di 5 opzioni",
                        type: "warn",
                    });
                }
            }
        },
        async saveVehicle(data) {
            const loader = this.$loading.show();

            this.isLicensePlatesListVisible = false;

            if (this.vehicleSearched?.immatricolazioneEstera == "si") {
                this.targaEstero = this.vehicleSearched.targaEstero;
                this.statoEstero = this.vehicleSearched?.statoEstero;
                this.dataImmatricolazioneEstero = this.format(this.vehicleSearched?.dataImmatricolazioneEstero, "YYYY-MM-DD", "DD/MM/YYYY");
                this.isImmatricolazioneEstera = true;
            } else {
                this.targaEstero = "";
                this.statoEstero = "";
                this.dataImmatricolazioneEstero = this.format(this.vehicleSearched?.dataImmatricolazioneEstero, "YYYY-MM-DD", "DD/MM/YYYY");
                this.isImmatricolazioneEstera = false;
            }

            this.isSavingMode = true;
            this.marca = data?.marca?.acronimo;

            this.gamme = [...this.vehicleSearched?.gamme];
            if (this.gamme.length == 1) {
                this.gamma = this.gamme[0]?.codice;
            }

            this.modelli = [...this.vehicleSearched?.modelli.map(item => {
                if (!item.codDescModello?.codice) {
                    item.codDescModello = { ...item?.gammaModello };
                }

                return item;
            })];

            if (this.modelli.length == 1) {
                if (this.vehicleSearched.modelli[0]?.codDescModello?.codice) {
                    this.modello = this.vehicleSearched.modelli[0].codDescModello.codice;
                } else if (this.vehicleSearched.modelli[0]?.gammaModello?.codice) {
                    this.modello = this.vehicleSearched.modelli[0].gammaModello.codice;
                }
            }

            this.porte = [...this.vehicleSearched?.porte];
            if (this.porte.length == 1) {
                this.porta = this.porte[0];
            }

            this.passi = [...this.vehicleSearched.passi];
            if (this.passi?.length == 1) {
                this.passo = this.passi[0];
            }

            this.versioni = [...this.vehicleSearched?.versioni.map(item => {
                item.nome = item?.versione;
                return item;
            })];

            this.versione = data?.codiceEurotax;

            const versioneSelected = this.versioni.find(item => item.codiceEurotax === this.versione);
            this.mainStore.allestimentoVeicolo = { marcaNome: versioneSelected?.marca?.nome, versione: versioneSelected?.versione };

            this.anni = [];
            this.anno = "";
            this.mesi = [];
            this.mese = "";
            if (this.targa) {
                this.tipologie = [...this.vehicleSearched.tipologie];
                if (this.tipologie.length == 1) {
                    this.tipologia = this.tipologie[0]?.codice;
                }

                if (this.dataImmatricolazioneEstero) {
                    this.anni = [this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "YYYY")];
                    this.anno = this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "YYYY");
                    this.mesi = [this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "M")];
                    this.mese = this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "M");
                } else {
                    this.anni = [this.format(this.vehicleSearched?.dataImmatricolazione, "YYYY-MM-DD", "YYYY")];
                    this.anno = this.format(this.vehicleSearched?.dataImmatricolazione, "YYYY-MM-DD", "YYYY");
                    this.mesi = [this.format(this.vehicleSearched?.dataImmatricolazione, "YYYY-MM-DD", "M")];
                    this.mese = this.format(this.vehicleSearched?.dataImmatricolazione, "YYYY-MM-DD", "M");
                }
            } else {
                if (this.vehicleSearched?.tipologie) {
                    this.tipologie = [...this.vehicleSearched?.tipologie];
                } else if (this.vehicleSearched?.tipi) {
                    this.tipologie = [...this.vehicleSearched?.tipi];
                }

                if (this.tipologie.length == 1) {
                    this.tipologia = this.tipologie[0]?.codice;
                }

                if (this.dataImmatricolazioneEstero) {
                    this.anni = [this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "YYYY")];
                    this.anno = this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "YYYY");
                    this.mesi = [this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "M")];
                    this.mese = this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "M");
                } else {
                    this.anni = [data?.da.split("-")[0]];
                    this.anno = data?.da.split("-")[0];
                    this.mesi = [data?.da.split("-")[1]];
                    this.mese = data?.da.split("-")[1];
                }
            }

            if (this.anno == "" && this.mese == "") {
                this.isSelectMeseDisabled = true;
                loader.hide();
                return;
            }

            this.isSelectMarcaDisabled = false;
            this.isSelectAnnoDisabled = false;
            this.isSelectMeseDisabled = false;
            this.isSelectGammaDisabled = false;
            this.isSelectModelloDisabled = false;
            this.isSelectPortaDisabled = false;
            this.isSelectTipologiaDisabled = false;
            this.isSelectPassoDisabled = false;
            this.isSelectVersioneDisabled = false;

            this.vehicleSearched = {};
            this.mainStore.datiSearchTargaTipoVeicoloSbagliato = {};

            document.getElementById('selection').scrollIntoView({ behavior: 'smooth' });

            loader.hide();
        },
        async searchVehicle() {
            this.isLicensePlatesListVisible = false;

            if (!this.targa) {
                this.$notify({
                    title: "Attenzione",
                    text: "Inserire una targa",
                    type: "warn",
                });
                return;
            }

            const loader = this.$loading.show();

            this.resetForm();

            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/generali/targa?targa=${this.targa}&costruttore=`);

                this.isLicensePlatesListVisible = true;

                if (response.data?.tipoVeicolo && response.data.tipoVeicolo != "VEICOLI_COMM_IND") {
                    this.mainStore.datiSearchTargaTipoVeicoloSbagliato = { ...response.data };
                    if (response.data.tipoVeicolo == "DUE_RUOTE") {
                        this.mainStore.type = "moto";
                    } else {
                        this.mainStore.type = "auto";
                    }
                    this.$router.push("/forecast/ricerca-modello");
                }

                if (response.data?.versioni?.length < 1) {
                    this.datiVeicoloNonDisponibile = {
                        targa: response.data?.targa,
                        telaio: response.data?.telaio,
                        tipo: response.data?.tipoVeicolo,
                        codiceMotore: response.data?.codiceMotore,
                        codiceOmologazione: response.data?.codiceOmologazione,
                        dataImmatricolazione: response.data?.dataImmatricolazione,
                        dataUltimaRevisione: response.data?.dataUltimaRevisione,
                        immatricolazioneEstera: response.data?.immatricolazioneEstera,
                        statoEstero: response.data?.statoEstero,
                        targaEstero: response.data?.targaEstero,
                        dataImmatricolazioneEstero: response.data?.dataImmatricolazioneEstero
                    }
                    this.isNoDataPopupOpen = true;
                    loader.hide();
                    return;
                }

                this.vehicleSearched = response.data;
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella ricerca",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }

            loader.hide();
        },
        async submit() {
            if (this.mainStore?.mercato === 'usato') {
                if (!this.marca || !this.anno || !this.mese || !this.modello || !this.gamma || !this.versione || !this.kmAttuali || !this.kmAnnuali || this.numeroMesiForecast?.length < 1) {
                    this.$notify({
                        title: "Attenzione",
                        text: "Compilare tutti i campi prima di proseguire",
                        type: "warn",
                    });
                    return;
                }
            } else {
                if (!this.marca || !this.modello || !this.gamma || !this.versione || !this.kmAnnuali || this.numeroMesiForecast?.length < 1) {
                    this.$notify({
                        title: "Attenzione",
                        text: "Compilare tutti i campi prima di proseguire",
                        type: "warn",
                    });
                    return;
                }
            }

            const loader = this.$loading.show();

            await this.getForecast();
            if (this.forecast == null) {
                loader.hide();
                return;
            }

            this.$router.push("/forecast/forecast");

            loader.hide();
        },
        async getMarche(isNuovo) {
            let url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/vcom/marche?libro=false`;
            if (isNuovo) {
                url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/nuovo/vcom/marche?libro=false&km0=false`
            }

            try {
                const response = await axios.get(url)
                for (const marca in response?.data?.marche) {
                    this.marche.push({ acronimo: response?.data?.marche[marca]?.acronimo, nome: response?.data?.marche[marca]?.nome });
                }

                this.isSelectMarcaDisabled = false;
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle marche",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getAnni() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/vcom/anni?codice_marca=${this.marca}`);

                this.anni = [...response.data?.anni];
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento degli anni",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        getMesi() {
            this.mesi = [];

            try {
                for (let i = 1; i < 13; i++) {
                    this.mesi.push(i);
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento dei mesi",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getGamme(isNuovo) {
            let url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/vcom/gruppostorico/gamma?codice_marca=${this.marca}&anno=${this.anno}&mese=${this.mese}`;
            if (isNuovo) {
                url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/nuovo/vcom/gamma?codice_marca=${this.marca}&anno=${new Date().getFullYear()}&km0=false`;
            }

            try {
                const response = await axios.get(url);

                this.gamme = [...response.data?.gamme];
                if (this.gamme.length == 1) {
                    this.gamma = this.gamme[0]?.codice;
                    await this.getModelli(isNuovo);
                    this.isSelectModelloDisabled = false;
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle gamme",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getModelli(isNuovo) {
            let url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/vcom/gamma/modelli?codice_gamma=${this.gamma}&anno=${this.anno}`;
            if (isNuovo) {
                url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/nuovo/vcom/gamma/modelli?codice_gamma=${this.gamma}&anno=${new Date().getFullYear()}&km0=false`;
            }

            try {
                const response = await axios.get(url);

                this.modelli = [...response.data?.modelli];
                if (this.modelli.length == 1) {
                    this.modello = this.modelli[0]?.codDescModello?.codice;
                    await this.getPorte(isNuovo);
                    this.isSelectPortaDisabled = false;
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento dei modelli",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getPorte(isNuovo) {
            let url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/vcom/porte?codice_modello=${this.modello}&anno=${this.anno}`;
            if (isNuovo) {
                url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/nuovo/vcom/porte?codice_modello=${this.modello}&anno=${new Date().getFullYear()}&km0=false`;
            }

            try {
                const response = await axios.get(url);

                this.porte = [...response.data?.porte];
                if (this.porte.length == 1) {
                    this.porta = this.porte[0];
                    await this.getTipologie(isNuovo);
                    this.isSelectTipologiaDisabled = false;
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle porte",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getTipologie(isNuovo) {
            let url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/vcom/tipoVINC?codice_modello=${this.modello}&porte=${this.porta}`;
            if (isNuovo) {
                url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/nuovo/vcom/tipoVINC?codice_modello=${this.modello}&porte=${this.porta}&km0=false`;
            }

            try {
                const response = await axios.get(url);

                this.tipologie = [...response.data?.tipi];
                if (this.tipologie.length == 1) {
                    this.tipologia = this.tipologie[0]?.codice;
                    await this.getPassi(isNuovo);
                    this.isSelectPassoDisabled = false;
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle tipologie",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getPassi(isNuovo) {
            let url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/vcom/passiVINC?tipo=${this.tipologia}&codice_modello=${this.modello}&porte=${this.porta}`;
            if (isNuovo) {
                url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/nuovo/vcom/passiVINC?tipo=${this.tipologia}&codice_modello=${this.modello}&porte=${this.porta}&km0=false`;
            }

            try {
                const response = await axios.get(url);

                this.passi = [...response.data?.passi];
                if (this.passi.length == 1) {
                    this.passo = this.passi[0];
                    await this.getVersioni(isNuovo);
                    this.isSelectVersioneDisabled = false;
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento dei passi",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getVersioni(isNuovo) {
            let url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/vcom/versioni?codice_modello=${this.modello}&anno=${this.anno}&porte=${this.porta}&libro=false&tipologia=${this.tipologia}`;
            if (isNuovo) {
                url = `${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/nuovo/vcom/versione/priv?acronimo_marca=${this.marca}&get_img_modello=false&get_img_versione=false&codice_modello=${this.modello}&cod_tipologia=${this.tipologia}&porte=${this.porta}&km0=false`;
            }

            try {
                if (this.passo) {
                    url += `&passo=${this.passo}`;
                }

                const response = await axios.get(url);

                this.versioni = [...response.data?.versioni];
                if (this.versioni.length == 1) {
                    this.versione = this.versioni[0]?.codiceEurotax;
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle versioni",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        getDateFuture() {
            this.dateFuture = [];

            try {
                for (let i = 6; i <= 72; i += 6) {
                    this.dateFuture.push(i);
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle date future",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getForecast() {
            let request = {};

            const numeroMesiSorted = this.numeroMesiForecast.sort((a, b) => a - b);
            if (this.mainStore?.mercato === 'usato') {
                request = {
                    codiceEurotax: this.versione,
                    anno: this.anno,
                    mese: this.mese,
                    numeroMesi: numeroMesiSorted,
                    kmAttuali: this.kmAttuali,
                    kmAnnuali: this.kmAnnuali,
                    valoreTotaleAccessori: 0
                }
            } else {
                request = {
                    codiceEurotax: this.versione,
                    numeroMesi: numeroMesiSorted,
                    kmAttuali: this.kmAttuali,
                    kmAnnuali: this.kmAnnuali,
                    valoreTotaleAccessori: 0
                }
            }

            try {
                const response = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/public/usato/generali/forecast`, request,
                    { headers: { "content-type": "application/json" } });

                this.forecast = response.data;

                this.mainStore.forecast = { ...this.forecast };
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel forecast",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
    },
}
</script>